import React from "react";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Chip, Tooltip } from "@mui/material";
import { ApiKycLogs } from "types/admin";
import { apiLogToVerificationStep } from "./adminKycVerificationUtils";

const OUTCOME_ICONS = {
  SUCCESS: CheckCircleOutlineIcon,
  FAILURE: CancelOutlinedIcon,
  UNKNOWN: HelpOutlineIcon,
} as const;

const OUTCOME_COLORS = {
  SUCCESS: "success",
  FAILURE: "error",
  UNKNOWN: "default",
} as const;

interface PanComplianceIndicatorProps {
  complianceLog?: ApiKycLogs;
}

function PanComplianceIndicator({ complianceLog }: PanComplianceIndicatorProps) {
  if (!complianceLog) {
    return (
      <Tooltip title="PAN compliance check was not logged">
        <Chip
          size="small"
          variant="outlined"
          color="default"
          icon={<HelpOutlineIcon fontSize="small" />}
          label="Compliance"
          sx={{ height: 24 }}
        />
      </Tooltip>
    );
  }

  const step = apiLogToVerificationStep(complianceLog);
  const outcome = step?.outcome ?? "UNKNOWN";
  const Icon = OUTCOME_ICONS[outcome];
  const tooltip = step?.message
    ? `PAN Compliance: ${outcome === "SUCCESS" ? "Passed" : outcome === "FAILURE" ? "Failed" : "Unknown"} — ${step.message}`
    : `PAN Compliance: ${outcome === "SUCCESS" ? "Passed" : outcome === "FAILURE" ? "Failed" : "Unknown"}`;

  return (
    <Tooltip title={tooltip}>
      <Chip
        size="small"
        variant="outlined"
        color={OUTCOME_COLORS[outcome]}
        icon={<Icon fontSize="small" />}
        label="Compliance"
        aria-label={tooltip}
        sx={{ height: 24 }}
      />
    </Tooltip>
  );
}

export default PanComplianceIndicator;
